import Vue from 'vue'
import axios from 'axios'

Vue.prototype.$http = axios

// Sets the default url used by all of this axios instance's requests
axios.defaults.baseURL = process.env.VUE_APP_API_URL

axios.defaults.headers.get['Accept'] = 'application/json'
//axios.defaults.headers["language"] = "ne"

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
axios.defaults.headers.common["Accept"] = '*/*'

axios.interceptors.request.use(
  config => {
    Vue.prototype.$Progress.start();
    return config;
  },
  err => Promise.reject(err)
);